import { BaseService } from 'core/services';
import ProductTypeTagRouteService from './ProductTypeTagRouteService';

class ProductTypeTagService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ProductTypeTagRouteService());
    }
}

export default ProductTypeTagService;
